import type { SVGProps } from "react";
import { Sparkle } from "lucide-react";
import {
  defaultIconProps,
  type IconProps,
  sizeMap,
} from "modules/common/components/Icons/types";

type MatchedCardsIconProps = IconProps &
  Omit<SVGProps<SVGSVGElement>, "color" | "height" | "width">;

export function MatchedCardsIcon({
  size = defaultIconProps.size,
  color = defaultIconProps.color,
  className = "",
  fontSize,
  ...svgProps
}: MatchedCardsIconProps) {
  const pixelSize = fontSize ?? sizeMap[size as keyof typeof sizeMap];

  return (
    <Sparkle
      color={color}
      className={`inline-block ${className}`}
      width={pixelSize}
      height={pixelSize}
      {...svgProps}
    />
  );
}

export default MatchedCardsIcon;
